import debounce from 'lodash.debounce'
const contentHeaderTag = window.contentWithMenuHeadingTag || 'h2'
const isMobile = () => window.matchMedia('(max-width: 983px)').matches
/**
 * Finds an href in the content nav that links to the given element's id
 * and highlights it, and removes highlighting from other elements.
 * @param el | DOM Element
 */
const highlightNavItem = el => {
  const contentHeaderLinks = Array.from(
    document.querySelectorAll('#content_with_menu_nav > li')
  )

  contentHeaderLinks.forEach(navEl => {
    const link = Array.from(navEl.getElementsByTagName('a'))[0]
    const href = link.getAttribute('href').replace('#', '')
    if (href === el.id) {
      navEl.classList.add('--is-active')
    } else {
      navEl.classList.remove('--is-active')
    }
  })
}

/**
 * Scrolls to an element on the page.
 * @param el | DOM Element
 */
const scrollToElementOnPage = el => {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop
  const offset = isMobile ? 250 : 150
  const top = scrollTop + el.getBoundingClientRect().top - offset
  window.scrollTo({ top, behavior: 'smooth' })
}

window.handleNavClick = event => {
  const destination = document.querySelector(
    `#content ${contentHeaderTag}${event.srcElement.getAttribute('href')}`
  )
  window.location = event.srcElement.getAttribute('href')
  scrollToElementOnPage(destination)
}

const initObserver = () => {
  let observer = new IntersectionObserver(
    debounce(entries => {
      const visible = entries.filter(entry => entry.intersectionRatio !== 0)
      if (visible.length > 0) {
        const targetEntry = visible[0]
        highlightNavItem(targetEntry.target)
      }
    }, 25)
  )
  document.querySelectorAll(`#content ${contentHeaderTag}`).forEach(heading => {
    observer.observe(heading)
  })
}

window.addEventListener('load', initObserver)
